// @todo (CHAIR-18483) delete file after testing

import { getExperimentVariantObj } from 'chairisher/thirdparty/experiments';

export default function testAmplitudeExperiments() {
    const experimentVariantObj = getExperimentVariantObj('matthew-experiment-integration-test-client');
    console.info('amplitude experiment variant:', experimentVariantObj);
}
